import 'react-dates/initialize';
import 'moment/locale/nb';

import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import 'react-dates/lib/css/_datepicker.css';
import './index.css';

import App from './App';
import i18nWrapper from './i18n';

import * as serviceWorker from './serviceWorker';

const defaultLanguage = localStorage.getItem('language');

ReactDOM.render(
  <I18nextProvider i18n={i18nWrapper(defaultLanguage || 'English')}>
    <App />
  </I18nextProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
